<template>
  <div class="loading-spinner">
    <div class="spinner"></div>
  </div>
</template>